import {
    FETCH_PERSONAL_RECORD_BY_ACTIVITY_ID,
    FETCH_PERSONAL_RECORD_BY_ACTIVITY_ID_FETCHING,
    FETCH_PERSONAL_RECORD_BY_ACTIVITY_ID_SUCCESS,
    FETCH_PERSONAL_RECORD_BY_ACTIVITY_ID_FAIL
} from 'actions/ActionTypes.js';

const INITIAL_STATE = {
    data: {},
    personalRecordByActivityIdFetching: false,
    personalRecordByActivityIdFetchFail: false
};

// ======= Fetching Handlers =======
const fetchPersonalRecordByActivityIdFetching = (state, action) => {
    return {
        ...state,
        personalRecordByActivityIdFetching: true,
        personalRecordByActivityIdFetchFail: false
    };
};

const fetchPersonalRecordByActivityIdSuccess = (state, action) => {
    return {
        ...state,
        data: {
            ...state.data,
            [action.activityId]: [...action.data]
        },
        personalRecordByActivityIdFetching: false,
        personalRecordByActivityIdFetchFail: false
    };
};

const fetchPersonalRecordByActivityIdFail = (state, action) => {
    return {
        ...state,
        personalRecordByActivityIdFetching: false,
        personalRecordByActivityIdFetchFail: true
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_PERSONAL_RECORD_BY_ACTIVITY_ID_FETCHING]: fetchPersonalRecordByActivityIdFetching,
    [FETCH_PERSONAL_RECORD_BY_ACTIVITY_ID_SUCCESS]: fetchPersonalRecordByActivityIdSuccess,
    [FETCH_PERSONAL_RECORD_BY_ACTIVITY_ID_FAIL]: fetchPersonalRecordByActivityIdFail
};

// ======= Default Action ======
export default function personalRecordByActivityId(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function fetchPersonalRecordByActivityId(activityId, evictCache) {
    return {
        activityId: activityId,
        type: FETCH_PERSONAL_RECORD_BY_ACTIVITY_ID,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export const getPersonalRecordByActivityId = (state, activityId) => {
    if (!activityId) {
        return [];
    }
    if (!state.personalRecordByActivityId || !state.personalRecordByActivityId.data) {
        return [];
    }
    return state.personalRecordByActivityId.data[activityId] || [];
};
